// extracted by mini-css-extract-plugin
export default {"containerTop":"Top_containerTop__4Zanq","arrowIcon":"Top_arrowIcon__PmL52","slideIn":"Top_slideIn__+cL0G","slideInFromLeft":"Top_slideInFromLeft__OREgK"};